import { curry } from 'ramda';
import lodashTemplate from 'lodash.template';

export const template = curry((templateString, variables) =>
  lodashTemplate(templateString)(variables)
);
